import { render, staticRenderFns } from "./verification-card.vue?vue&type=template&id=110feb98&scoped=true"
import script from "./verification-card.vue?vue&type=script&lang=js"
export * from "./verification-card.vue?vue&type=script&lang=js"
import style0 from "./verification-card.vue?vue&type=style&index=0&id=110feb98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110feb98",
  null
  
)

export default component.exports